import { render, staticRenderFns } from "./InvestmentCard.vue?vue&type=template&id=56248327&scoped=true&"
import script from "./InvestmentCard.vue?vue&type=script&lang=js&"
export * from "./InvestmentCard.vue?vue&type=script&lang=js&"
import style0 from "./InvestmentCard.vue?vue&type=style&index=0&id=56248327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56248327",
  null
  
)

export default component.exports